document.documentElement.classList.remove('no-js');

class WreathQueenTheme {
  constructor(root = document) {
    this.root = root;
    this.bindVariantSelectors();
    this.bindCardVariantSelectors();
    this.bindMobileMenu();
  }

  bindCardVariantSelectors() {
    this.root.querySelectorAll('.js-card-variant-select').forEach((select) => {
      if (select.dataset.initialized === 'true') return;
      select.dataset.initialized = 'true';

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const card = select.closest('.product-card');
        const price = card?.querySelector('.price__current');
        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }
      });
    });
  }

  bindVariantSelectors() {
    this.root.querySelectorAll('.js-variant-select').forEach((select) => {
      if (select.dataset.initialized === 'true') return;
      select.dataset.initialized = 'true';

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const productInfo = select.closest('.product-info');
        const price = productInfo?.querySelector('.price__current');
        const compare = productInfo?.querySelector('.price__compare');
        const button = productInfo?.querySelector('.product-form__submit');
        const available = option.dataset.available === 'true';

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (compare) {
          if (option.dataset.comparePrice && option.dataset.comparePrice !== option.dataset.price) {
            compare.textContent = option.dataset.comparePrice;
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }

        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Add to cart' : 'Sold out';
        }
      });
    });
  }

  bindMobileMenu() {
    this.root.querySelectorAll('.mobile-header-menu').forEach((menu) => {
      if (menu.dataset.initialized === 'true') return;
      menu.dataset.initialized = 'true';

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => menu.removeAttribute('open'));
      });
    });
  }
}

new WreathQueenTheme();

document.addEventListener('shopify:section:load', (event) => {
  new WreathQueenTheme(event.target);
});


/* Product media carousel */
(() => {
  const initProductCarousels = (root = document) => {
    root.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;

      const track = carousel.querySelector('.product-gallery__track');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const current = carousel.querySelector('[data-carousel-current]');

      if (!track || slides.length < 2) return;

      carousel.dataset.carouselInitialized = 'true';
      let index = 0;
      let touchStartX = 0;

      const showSlide = (targetIndex) => {
        index = (targetIndex + slides.length) % slides.length;
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';

        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
          if (slideIndex !== index) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
          }
        });

        if (current) current.textContent = String(index + 1);
      };

      previous?.addEventListener('click', () => showSlide(index - 1));
      next?.addEventListener('click', () => showSlide(index + 1));

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showSlide(index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showSlide(index + 1);
        }
      });

      carousel.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 50) return;
        showSlide(distance > 0 ? index - 1 : index + 1);
      }, { passive: true });

      showSlide(0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductCarousels());
  } else {
    initProductCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initProductCarousels(event.target));
})();


/* Product thumbnails and accordion dedupe */
(() => {
  const init = () => {
    const carousel = document.querySelector('[data-product-carousel]');
    const gallery = carousel && (carousel.closest('.product-gallery') || carousel.parentElement);
    if (carousel && gallery && !gallery.querySelector('[data-product-thumbnails]')) {
      const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      if (slides.length > 1) {
        const nav = document.createElement('div');
        nav.className = 'product-gallery__thumbnails';
        nav.dataset.productThumbnails = '';
        nav.setAttribute('aria-label', 'Product image thumbnails');
        slides.forEach((slide, index) => {
          const source = slide.querySelector('img');
          if (!source) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-gallery__thumbnail';
          button.dataset.productThumbnail = index;
          button.setAttribute('aria-label', 'Show product image ' + (index + 1));
          const image = source.cloneNode(false);
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.loading = 'lazy';
          button.appendChild(image);
          button.addEventListener('click', () => {
            const current = Math.max(0, slides.findIndex(item => item.getAttribute('aria-hidden') === 'false'));
            const forward = (index - current + slides.length) % slides.length;
            const backward = (current - index + slides.length) % slides.length;
            const control = forward <= backward ? next : prev;
            for (let i = 0; control && i < Math.min(forward, backward); i++) control.click();
          });
          nav.appendChild(button);
        });
        gallery.appendChild(nav);
        const sync = () => {
          const current = Math.max(0, slides.findIndex(item => item.getAttribute('aria-hidden') === 'false'));
          nav.querySelectorAll('[data-product-thumbnail]').forEach((button, index) => {
            button.classList.toggle('is-active', index === current);
            button.setAttribute('aria-current', index === current ? 'true' : 'false');
          });
        };
        slides.forEach(slide => new MutationObserver(sync).observe(slide, {attributes:true, attributeFilter:['aria-hidden']}));
        sync();
      }
    }
    document.querySelector('.product-page__grid')?.style.setProperty('row-gap', '0px');
    document.querySelector('[data-product-thumbnails]')?.style.setProperty('margin-top', '0px');
    const info = document.querySelector('.product-page__info, .product-info, .product__info-wrapper');
    if (info) {
      const seen = new Set();
      info.querySelectorAll('details').forEach(details => {
        const label = (details.querySelector('summary')?.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
        if (!label) return;
        if (seen.has(label)) details.hidden = true;
        else seen.add(label);
      });
    }
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();


/* Click-to-zoom product image lightbox */
(() => {
  const initProductLightbox = () => {
    const carousel = document.querySelector('[data-product-carousel]');
    if (!carousel || carousel.dataset.productLightboxReady === 'true') return;
    carousel.dataset.productLightboxReady = 'true';

    const lightbox = document.createElement('div');
    lightbox.className = 'product-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Enlarged product image');
    lightbox.innerHTML = '<button class="product-lightbox__close" type="button" aria-label="Close enlarged image">&times;</button><img class="product-lightbox__image" alt="">';
    document.body.appendChild(lightbox);

    const lightboxImage = lightbox.querySelector('.product-lightbox__image');
    const closeButton = lightbox.querySelector('.product-lightbox__close');
    let previousOverflow = '';

    const closeLightbox = () => {
      lightbox.hidden = true;
      lightbox.classList.remove('is-open');
      document.body.style.overflow = previousOverflow;
    };

    const openLightbox = (source) => {
      lightboxImage.src = source.currentSrc || source.src;
      lightboxImage.alt = source.alt || 'Product image';
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      lightbox.hidden = false;
      lightbox.classList.add('is-open');
      closeButton.focus();
    };

    carousel.addEventListener('click', (event) => {
      const image = event.target.closest('[data-carousel-slide] img');
      if (!image) return;
      event.preventDefault();
      openLightbox(image);
    });

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLightbox);
  } else {
    initProductLightbox();
  }
  document.addEventListener('shopify:section:load', initProductLightbox);
})();


/* Local wishlist for product cards, product pages, and header Favorites */
(() => {
  const key = 'wreathqueen_wishlist_v1';
  const getItems = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };
  const saveItems = items => localStorage.setItem(key, JSON.stringify(items));
  const path = url => {
    try { return new URL(url, location.origin).pathname.replace(/\/$/, ''); }
    catch (error) { return url; }
  };
  let items = getItems();

  const ensureDrawer = () => {
    let overlay = document.querySelector('[data-wishlist-overlay]');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'wishlist-overlay';
    overlay.dataset.wishlistOverlay = '';
    overlay.hidden = true;
    overlay.innerHTML = '<aside class="wishlist-drawer" role="dialog" aria-modal="true" aria-label="Favorites"><header class="wishlist-drawer__header"><h2>Favorites</h2><button type="button" data-wishlist-close aria-label="Close favorites">&times;</button></header><div class="wishlist-drawer__body" data-wishlist-items></div></aside>';
    document.body.appendChild(overlay);
    const close = () => {
      overlay.hidden = true;
      overlay.classList.remove('is-open');
      document.body.classList.remove('wishlist-is-open');
    };
    overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
    overlay.querySelector('[data-wishlist-close]').addEventListener('click', close);
    document.addEventListener('keydown', event => { if (event.key === 'Escape' && !overlay.hidden) close(); });
    return overlay;
  };

  const render = () => {
    const overlay = ensureDrawer();
    const body = overlay.querySelector('[data-wishlist-items]');
    body.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('div');
      empty.className = 'wishlist-empty';
      empty.innerHTML = '<p>Your favorites list is empty.</p><p>Tap a heart to save a product here.</p>';
      body.appendChild(empty);
      return;
    }
    const list = document.createElement('ul');
    list.className = 'wishlist-list';
    items.forEach(item => {
      const row = document.createElement('li');
      row.className = 'wishlist-item';
      const link = document.createElement('a');
      link.className = 'wishlist-item__link';
      link.href = item.url;
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        link.appendChild(image);
      }
      const text = document.createElement('span');
      text.innerHTML = '<strong></strong><small></small>';
      text.querySelector('strong').textContent = item.title;
      text.querySelector('small').textContent = item.price || '';
      link.appendChild(text);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-item__remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', () => {
        items = items.filter(saved => saved.url !== item.url);
        saveItems(items);
        update();
      });
      row.append(link, remove);
      list.appendChild(row);
    });
    body.appendChild(list);
  };

  const update = () => {
    document.querySelectorAll('[data-wishlist-count]').forEach(count => {
      count.textContent = items.length;
      count.hidden = !items.length;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const active = items.some(item => item.url === path(button.dataset.wishlistUrl));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active);
      if (button.classList.contains('wishlist-product-toggle')) {
        button.innerHTML = '<span aria-hidden="true">' + (active ? '♥' : '♡') + '</span> ' + (active ? 'Remove from favorites' : 'Add to favorites');
      } else {
        button.textContent = active ? '♥' : '♡';
      }
    });
    const overlay = document.querySelector('[data-wishlist-overlay]');
    if (overlay && !overlay.hidden) render();
  };

  const toggle = product => {
    product.url = path(product.url);
    if (items.some(item => item.url === product.url)) items = items.filter(item => item.url !== product.url);
    else items.push(product);
    saveItems(items);
    update();
  };

  const bind = (root = document) => {
    ensureDrawer();

    root.querySelectorAll('a[href="/pages/wishlist"], a[href$="/pages/wishlist"]').forEach(link => {
      if (link.dataset.wishlistBound) return;
      link.dataset.wishlistBound = 'true';
      const count = document.createElement('span');
      count.className = 'wishlist-count';
      count.dataset.wishlistCount = '';
      count.hidden = true;
      link.appendChild(count);
      link.addEventListener('click', event => {
        event.preventDefault();
        render();
        const overlay = ensureDrawer();
        overlay.hidden = false;
        overlay.classList.add('is-open');
        document.body.classList.add('wishlist-is-open');
        overlay.querySelector('[data-wishlist-close]').focus();
      });
    });

    root.querySelectorAll('.product-card').forEach(card => {
      if (card.querySelector('[data-wishlist-toggle]')) return;
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      const title = (card.querySelector('.product-card__title, h2, h3')?.textContent || link.textContent || 'Product').trim();
      const price = (card.querySelector('.product-card__price, .price')?.textContent || '').trim();
      const image = card.querySelector('img');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'wishlist-card-toggle';
      button.dataset.wishlistToggle = '';
      button.dataset.wishlistUrl = path(link.href);
      button.setAttribute('aria-label', 'Add ' + title + ' to favorites');
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggle({url: link.href, title, price, image: image ? (image.currentSrc || image.src) : ''});
      });
      card.appendChild(button);
    });

    if (location.pathname.includes('/products/') && !root.querySelector('.wishlist-product-toggle')) {
      const info = root.querySelector('.product-info, .product-page__info, .product__info-wrapper');
      const heading = info?.querySelector('h1');
      if (heading) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wishlist-product-toggle';
        button.dataset.wishlistToggle = '';
        button.dataset.wishlistUrl = path(location.pathname);
        button.addEventListener('click', () => {
          const image = root.querySelector('[data-carousel-slide][aria-hidden="false"] img, [data-product-carousel] img');
          const price = (info.querySelector('.product-info__price, .product-price, .price')?.textContent || '').trim();
          toggle({url: location.pathname, title: heading.textContent.trim(), price, image: image ? (image.currentSrc || image.src) : ''});
        });
        heading.insertAdjacentElement('afterend', button);
      }
    }
    update();
  };

  items = getItems();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();


/* WreathQueen autumn product experience */
(function () {
  function initAutumnProduct(root) {
    if (!root || root.dataset.autumnProductReady === 'true') return;
    root.dataset.autumnProductReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-autumn-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-autumn-thumb]'));
    var prev = root.querySelector('[data-autumn-prev]');
    var next = root.querySelector('[data-autumn-next]');
    var counter = root.querySelector('[data-autumn-current]');
    var activeIndex = 0;

    function showSlide(index) {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(Number(thumb.dataset.index || 0));
      });
    });
    if (prev) prev.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(activeIndex + 1); });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    var quantity = root.querySelector('input[name="quantity"]');
    var minus = root.querySelector('[data-autumn-quantity-minus]');
    var plus = root.querySelector('[data-autumn-quantity-plus]');
    if (quantity && minus) {
      minus.addEventListener('click', function () {
        quantity.value = String(Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 1));
      });
    }
    if (quantity && plus) {
      plus.addEventListener('click', function () {
        quantity.value = String(Number(quantity.value || 1) + 1);
      });
    }

    var variantSelect = root.querySelector('[data-autumn-variant-select]');
    var price = root.querySelector('[data-autumn-price]');
    var addButton = root.querySelector('[data-autumn-add-to-cart]');
    var addText = root.querySelector('[data-autumn-add-text]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var available = option.dataset.available === 'true';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (addButton) addButton.disabled = !available;
        if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
        if (option.dataset.url && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', option.dataset.url);
        }
      });
    }

    var lightbox = root.querySelector('[data-autumn-lightbox]');
    var lightboxImage = root.querySelector('[data-autumn-lightbox-image]');
    var lightboxClose = root.querySelector('[data-autumn-lightbox-close]');
    root.querySelectorAll('[data-autumn-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var sourceImage = trigger.querySelector('img');
        if (!lightbox || !lightboxImage || !sourceImage) return;
        lightboxImage.src = trigger.dataset.zoomSrc || sourceImage.currentSrc || sourceImage.src;
        lightboxImage.alt = sourceImage.alt || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      });
    });
    if (lightboxClose) {
      lightboxClose.addEventListener('click', function () {
        if (typeof lightbox.close === 'function') lightbox.close();
        else lightbox.removeAttribute('open');
      });
    }
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox && typeof lightbox.close === 'function') lightbox.close();
      });
    }

    showSlide(0);
  }

  function initAllAutumnProducts() {
    document.querySelectorAll('[data-autumn-product]').forEach(initAutumnProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAutumnProducts);
  } else {
    initAllAutumnProducts();
  }
  document.addEventListener('shopify:section:load', initAllAutumnProducts);
})();



(function () {
  function bindCartQuantity(root) {
    root.querySelectorAll('[data-cart-quantity]').forEach(function (stepper) {
      if (stepper.dataset.bound === 'true') return;
      stepper.dataset.bound = 'true';

      var input = stepper.querySelector('input');
      var minus = stepper.querySelector('[data-cart-quantity-minus]');
      var plus = stepper.querySelector('[data-cart-quantity-plus]');
      if (!input || !minus || !plus) return;

      function update(delta) {
        var current = parseInt(input.value, 10);
        if (Number.isNaN(current)) current = 0;
        input.value = Math.max(0, current + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function () { update(-1); });
      plus.addEventListener('click', function () { update(1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindCartQuantity(document); });
  } else {
    bindCartQuantity(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindCartQuantity(event.target);
  });
})();


/* WreathQueen compare-at price support for product variants */
(function () {
  function bindComparePrice(root) {
    var select = root.querySelector('[data-autumn-variant-select]');
    var comparePrice = root.querySelector('[data-autumn-compare-price]');
    if (!select || !comparePrice || select.dataset.comparePriceBound === 'true') return;
    select.dataset.comparePriceBound = 'true';

    function updateComparePrice() {
      var option = select.options[select.selectedIndex];
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = option.dataset.showCompare !== 'true';
    }

    select.addEventListener('change', updateComparePrice);
    updateComparePrice();
  }

  function bindAllComparePrices() {
    document.querySelectorAll('[data-autumn-product]').forEach(bindComparePrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllComparePrices);
  } else {
    bindAllComparePrices();
  }
  document.addEventListener('shopify:section:load', bindAllComparePrices);
})();

